/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Grid, InputLabel, TextField } from "@mui/material";
import { FC, Fragment, useState } from "react";
import { useFormik } from "formik";
import InputTextfield from "../../../../../shared/components/textField";
import { FormContainer } from "../../../../../shared/components/formContainer";
import useMutation from "../../../../../shared/components/hooks/useMutation";
import SingleEntityImageViewer from "../../../../../shared/components/singleEntityImageViewer";
import ToggleSwitch from "../../../../../shared/components/switch";
import { customizeValidationSchema } from "../variables/customSchema";
import { getTextFields } from "../variables/textFields";
import { ProfileBorderBox } from "../../../../../shared/components/profileComponents";

const JobTypeCreate: FC = () => {
  const { loading: apiLoading, modifyData } = useMutation(
    "/master-datas/job-types"
  );
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  const textFields = getTextFields({});

  const initialValues = {
    name: "",
    iconURL: null,
    enabled: true,
  };
  const jobTypeForm = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validateOnBlur: true,
    validationSchema: customizeValidationSchema(),
    onSubmit: async (formData: any) => {
      const formDataJobType = new FormData();
      formDataJobType.append("file", formData.iconURL);
      formDataJobType.append("name", formData.name);
      formDataJobType.append("enabled", formData.enabled ? "true" : "false");

      modifyData(`/job-type`, "post", formDataJobType, jobTypeForm);
    },
  });

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      setPreviewUrl(URL.createObjectURL(file));
      jobTypeForm.setFieldValue("iconURL", file);
    } else {
      setPreviewUrl(null);
      jobTypeForm.setFieldValue("iconURL", null);
    }
  };

  const titleBar = {
    headerTitle: "Job Type - Create",
    title: "Job Types",
    buttonTitle: "Save",
    onClick: () => jobTypeForm.handleSubmit(),
    dirty: jobTypeForm.dirty,
    buttonLoading: apiLoading,
  };

  return (
    <>
      <ProfileBorderBox>
        <FormContainer titleBar={titleBar}>
          <Box className="border-custom">
            <Grid
              container
              alignItems="stretch"
              columnSpacing={4}
              rowSpacing={2}
            >
              <Grid item xs={12}>
                <ToggleSwitch
                  status={jobTypeForm?.values?.enabled}
                  handleChange={() =>
                    jobTypeForm.setFieldValue(
                      "enabled",
                      !jobTypeForm?.values?.enabled
                    )
                  }
                />
              </Grid>

              {textFields.map((field: any, index: number) => (
                <Fragment key={field.id}>
                  {(field?.formField === undefined ||
                    field.formField === true) && (
                    <Grid item md={6} sm={6} xs={12}>
                      <InputTextfield
                        form={jobTypeForm}
                        fieldProps={field}
                        key={index}
                      />
                    </Grid>
                  )}
                </Fragment>
              ))}
              <Grid item md={6} sm={6} xs={6} key="jobType-iconURL">
                <InputLabel>Icon</InputLabel>
                <TextField
                  size="small"
                  fullWidth
                  id="outlined-basic"
                  type={"file"}
                  sx={{
                    marginTop: "1vh",
                    "& .MuiInputBase-root": {
                      height: "40px",
                      fontSize: "1rem",
                    },
                  }}
                  onChange={handleFileChange}
                />
              </Grid>
              <Grid item md={3} sm={6} xs={6} key="jobType-iconPreview">
                <div>
                  <SingleEntityImageViewer src={previewUrl} alt="Event" />
                </div>
              </Grid>
            </Grid>
          </Box>
        </FormContainer>
      </ProfileBorderBox>
    </>
  );
};
export default JobTypeCreate;
